<div class="container">
    <!--image de fond à superposer au élément présent dans la grille-->
    <img *ngIf="picture" [src]="picture" alt="Image Preview" class="image"/>
    <app-activity-edition-point-img-grid class="overlay">
        <!-- contenu de la grille est injecté ici-->
        <ng-content></ng-content>
    </app-activity-edition-point-img-grid>
</div>